import type { Theme } from '@mui/material/styles'
import type { SystemStyleObject } from '@mui/system'
import { tabularToolbarBand } from '@/shared/form/formChrome'
import type { Density, DensityTokens } from '@/shared/density/densityTokens'

/** Vertical hairline. Last cell of the row (Actions) drops the right border. */
export const listCellHairlineSx: SystemStyleObject<Theme> = {
  borderRight: (theme) => `1px solid ${theme.palette.divider}`,
  '&:last-of-type': { borderRight: 'none' },
}

/** Sticky header cell. Fill matches tabular-part column heads (`tabularToolbarBand`). */
export const listHeaderStickySx: SystemStyleObject<Theme> = {
  position: 'sticky',
  top: 0,
  zIndex: 3,
  bgcolor: (theme) => tabularToolbarBand(theme),
  textAlign: 'left',
}

export function listNumericBodySx(numeric: boolean): SystemStyleObject<Theme> {
  return numeric
    ? { textAlign: 'right', fontVariantNumeric: 'tabular-nums' }
    : { textAlign: 'left' }
}

/** Overrides the Operator theme's fixed TableCell 8/8 padding so density actually changes row height. */
export function listDensityCellSx(tokens: DensityTokens): SystemStyleObject<Theme> {
  return { py: `${tokens.cellPaddingY}px` }
}

/** Compact IconButton/Checkbox padding — default size="small" (~30–38px) blocks 28px rows. */
export function listDensityControlSx(density: Density): SystemStyleObject<Theme> {
  return density === 'compact' ? { p: 0.25 } : {}
}
